export const setCheckedOptionsNames = (items) => items.filter((item) => item.checked).map((item) => item.name);
export const setDefaultCheckboxesOptions = (items, checkNamesArray) => {
    const isCheckedArray = checkNamesArray?.value || [];
    return items.map((item) => ({
        name: item,
        value: item,
        checked: isCheckedArray.includes(item),
    }));
};
export const setCheckedStateForAll = (optionsState, isChecked) => optionsState.map(({ value, label }) => ({
    value,
    label,
    checked: isChecked,
}));
export const setCheckedCheckboxes = (arrayToFilter, filterArray) => arrayToFilter.map((item) => ({
    ...item,
    checked: filterArray?.includes(item.name) ? item.checked : false,
}));
export function hasChangedFields(options, selectedOptions) {
    const [activeElements, unActiveItems] = options.reduce((acc, cur) => {
        if (selectedOptions?.includes(cur.name)) {
            acc[0].push(cur);
        }
        else {
            acc[1].push(cur);
        }
        return acc;
    }, [[], []]);
    const isActiveChanged = activeElements.every((element) => element.checked);
    const isUnActiveChanged = unActiveItems.every((element) => !element.checked);
    return !(isActiveChanged && isUnActiveChanged);
}
